// App-level error boundary: render failures show a retry state instead of a
// white screen.
import { Component } from "react";

import ErrorState from "components/ErrorState";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorState
          title="Something went wrong"
          message={String(this.state.error?.message || this.state.error)}
          onRetry={() => this.setState({ error: null })}
        />
      );
    }
    return this.props.children;
  }
}
